








































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../../Models/Components.model";
import ButtonList from "../../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../../Base/ParticaBaseForm.vue";
import { ListItemDTO, SectionModel } from "../../../Generated/ParticaAPI";
import { ITOCArticle } from "../../../Models/ArticleModels/article";

@Component(
	{
		name: "TocForm",
		components: { ButtonList }
	})
export default class TocForm extends ParticaBaseForm<ITOCArticle> {
	@Prop() private sections: SectionModel[];

	private pageNumberconfig =
		{
			props: { name: "pageNumber", placeholder: "Enter pageNumber", label: "Page Number", } as FormFieldProps,
			rules: { required: true, numeric: true, min_value: 1 } as FormFieldRules
		} as IFormField;

	private titleconfig =
		{
			props: { name: "title", placeholder: "Enter title", label: "Title", } as FormFieldProps,
			rules: { required: true, max: 700, min: 0, } as FormFieldRules
		} as IFormField;

	private abstractconfig =
		{
			props: { name: "abstract", placeholder: "Enter abstract", label: "Abstract/Description", } as FormFieldProps,
			rules: { required: true, max: 1000, min: 0, } as FormFieldRules
		} as IFormField;

	private sectionconfig =
		{
			props: { name: "section", placeholder: "Enter section", label: "Section", required: true } as FormFieldProps,
			rules: { required: true, min_value: 0 } as FormFieldRules
		} as IFormField;

	@Watch("model")
	private checkreset() {
		if (this.model.id === 0) {
			this.$validator.reset();
		}
	}
}
